class NavTabs {
  constructor () {
    this.setupListeners()
  }

  setupListeners () {
    this.handleTabChange = this.handleTabChange.bind(this)

    document.addEventListener('click', this.handleTabChange)
  }

  handleTabChange (event) {
    if (!event.target.closest('[data-nav-tabs-el="trigger"]')) return

    const clickedTrigger = event.target.closest('[data-nav-tabs-el="trigger"]')

    const triggerEls = document.querySelectorAll(
      '[data-nav-tabs-el="trigger"]',
    )
    const panelEls = document.querySelectorAll('[data-nav-tabs-el="panel"]')

    triggerEls.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.index === clickedTrigger.dataset.index,
      )
    })

    panelEls.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new NavTabs()
})
